var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86715 8C7.53692 8 6.66663 8.87319 6.66663 10.0204C6.66663 11.1433 7.51169 12.0417 8.81611 12.0417H8.84134C10.1977 12.0417 11.041 11.1433 11.041 10.0204C11.0152 8.87319 10.1977 8 8.86715 8ZM24.8056 18.6262V25.3333H20.917V19.0757C20.917 17.5045 20.3555 16.4315 18.9476 16.4315C17.8731 16.4315 17.2348 17.1539 16.9529 17.8533C16.8506 18.1033 16.8242 18.4505 16.8242 18.8011V25.333H12.9353C12.9353 25.333 12.9875 14.7347 12.9353 13.6376H16.8245V15.295C16.8208 15.3011 16.8164 15.3071 16.8121 15.3131C16.8072 15.3199 16.8024 15.3266 16.7987 15.3332H16.8245V15.295C17.3413 14.4998 18.2629 13.363 20.3291 13.363C22.8875 13.363 24.8056 15.0345 24.8056 18.6262ZM10.7852 25.3333H6.89776V13.6376H10.7852V25.3333Z",
    fill: "#C2D1D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_826_17178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 19,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86715 8C7.53692 8 6.66663 8.87319 6.66663 10.0204C6.66663 11.1433 7.51169 12.0417 8.81611 12.0417H8.84134C10.1977 12.0417 11.041 11.1433 11.041 10.0204C11.0152 8.87319 10.1977 8 8.86715 8ZM24.8056 18.6262V25.3333H20.917V19.0757C20.917 17.5045 20.3555 16.4315 18.9476 16.4315C17.8731 16.4315 17.2348 17.1539 16.9529 17.8533C16.8506 18.1033 16.8242 18.4505 16.8242 18.8011V25.333H12.9353C12.9353 25.333 12.9875 14.7347 12.9353 13.6376H16.8245V15.295C16.8208 15.3011 16.8164 15.3071 16.8121 15.3131C16.8072 15.3199 16.8024 15.3266 16.7987 15.3332H16.8245V15.295C17.3413 14.4998 18.2629 13.363 20.3291 13.363C22.8875 13.363 24.8056 15.0345 24.8056 18.6262ZM10.7852 25.3333H6.89776V13.6376H10.7852V25.3333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_826_17178)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.525829f08b1d082958a5f9fb5307179f.svg";
export { ForwardRef as ReactComponent };